import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sidebarShow: true,
  theme: "light",
};
export const Slice = createSlice({
  name: "settings",
  initialState: initialState,
  reducers: {
    set: (state, action) => {
      // The payload will be directly merged into the state
      return { ...state, ...action.payload };
    },
  },
  extraReducers: (builder) => {},
});

// Export actions (if needed in components)
export const { set } = Slice.actions;

export default Slice.reducer;
